export default __webpack_public_path__ + "static/media/sidebar-item-checked.03fa4212.svg";